
import { TranslationRecord } from '../../types';

export const common: TranslationRecord = {
  // Additional common strings
  bestRateMessage: 'Best available rate offered only when booking direct',
  
  // Amenities
  freeWifi: 'Free Wi-Fi',
  flatScreenTV: 'Flat-screen TV',
  hairDryer: 'Hair Dryer',
  toiletries: 'Toiletries',
  miniBar: 'Mini Bar',
  safeBox: 'Safe Box',
  
  // Common Words
  explore: 'Explore',
  more: 'More',
  book: 'Book',
  view: 'View',
  read: 'Read',
  
  // Months and dates 
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December'
};
